<template>
  <div id="AdminSpiderV2" v-if="this.userData.data.username=='admin'">
    <!-- <Breadcrumb :list="list"/> -->
    <div v-show="loader">
      <Loader />
    </div>
    <div class="datepickerwrap">
      <div class="leftcontent wrapitem">    
        <div class="datebox" style="min-width:17%">
          <select v-model="client" class="form-control text-uppercase">
            <option value="philips">Philips</option>
          </select>
        </div>
        <!-- <div class="datebox">
          <select v-model="device" @change="refresh"  class="form-control text-uppercase">
            <option value="laptop">Laptop PC</option>
            <option value="desktop">Desktop</option>
          </select>
        </div>  -->
        <div class="datebox">
          <button @click="refreshDataAPIs" class="btn btn-block weavrpurple">Submit</button>
        </div>
      </div>       
    </div> 
    <div class="container-fluid" >
      <div class="space-between-header">
        <h3>Spider List </h3>
      </div>
      <table class="table">
        <thead>
          <tr>
            <th v-for="td in spiderData.headers">{{ td.label }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in spiderData.data">
            <td v-for="td in spiderData.headers.slice(0,2)">{{ row[td.key] }}</td>
            <td>
              <button @click="startSpider(row['action'])" class="btn btn-primary">Start</button>
            </td>
          </tr>
        </tbody>
      </table>
  
      <div class="space-between-header">
        <h3>Running Spiders </h3>
      </div>  
       <table class="table">
        <thead>
          <tr>
            <th v-for="td in spiderRunningData.headers">{{ td.label }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in spiderRunningData.data">
            <td v-for="td in spiderRunningData.headers.slice(0,3)">
              <span v-if="td.key!='start_time'">{{ row[td.key] }}</span>
              <span v-if="td.key=='start_time'">{{ moment(row[td.key]).format('DD-MMM-YYYY HH:mm A') }}</span>
            </td>
            <td>
              <button @click="terminateSpider(row['spider_id'])" class="btn btn-danger">Terminate</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>  
  </div>
  
</template>

<script> 

import moment from 'moment'
import Datepicker from 'vuejs-datepicker'
import Loader from '../Components/Loader.vue';

export default {
  name: 'AdminSpiderV2',
  components: {
    Datepicker,
    Loader
  },

  data: function () {
    return {
      moment:moment,
      userData: JSON.parse(localStorage.getItem('reviewUserData')),
      customData: JSON.parse(localStorage.getItem('reviewCustomData')),
      loader: false,
      client: 'philips',
      date:{
        startDate: moment().format('YYYY-MM-DD'),
        endDate: moment().subtract(1,'days').format('YYYY-MM-DD')
      }, 
      spiderData: [],
      clients: [],
      spiderRunningData: []
    }
  },
  mounted()
  { 
    this.getClients()
  },
  methods: {
    refreshDataAPIs(){
      this.getAllSpiders()
      this.getRunningSpiders()
    },

    startSpider(d){
      let self = this
      this.loader = true
      let payload = {
        spider_name: d
      }
      const url = "/api/admin_pannel/schedule_spiders"
      self.$http.post(url, payload ).then(response => {
        self.loader = false
        setTimeout(function(){
          self.refreshDataAPIs()  
        },6000)
      }, err => {
        self.loader = false
      });
    },
    terminateSpider(d){
      let self = this
      this.loader = true
      let payload = {
        job_id: d
      }
      const url = "/api/admin_pannel/terminate_spider"
      self.$http.post(url, payload ).then(response => {
        self.loader = false
        self.refreshDataAPIs()  
      }, err => {
        self.loader = false
      });
    },
    getClients(){
      let self = this
      this.loader = true
      let payload = {}
      const url = "/api/admin_pannel/get_client_list"
      self.$http.post(url, payload ).then(response => {
        self.loader = false
        self.clients = response.body.data
        self.refreshDataAPIs()
      }, err => {
        self.loader = false
      });
    },
 
    getAllSpiders(){
      let self = this
      this.loader = true
      let payload = {
        client: 'philips' 
      }
      const url = "/api/admin_pannel/get_all_spiders"
      self.$http.post(url, payload ).then(response => {
        self.loader = false
        self.spiderData = response.body.data
      }, err => {
        self.loader = false
      });
    },
    getRunningSpiders(){
      let self = this
      this.loader = true
      let payload = {
        client: 'philips' 
      }
      const url = "/api/admin_pannel/running_spiders"
      self.$http.post(url, payload ).then(response => {
        self.loader = false
        self.spiderRunningData = response.body.data
      }, err => {
        self.loader = false
      });
    }
  }
}

</script>

<style scoped>
  /* IE fix */
  #card-chart-01, #card-chart-02 {
    width: 100% !important;
  }
  .card_vivo
  {
    background-color: #0072ba !important;
    border: 1px solid #0072ba !important;
  }
  .card_realme
  {
    background-color: #f3b821 !important;
    border: 1px solid #f3b821 !important;
  }
  .card_redmi
  {
    background-color: #f56628 !important; 
    border: 1px solid #f56628 !important;
  }

  .badge
  {
    padding: 5px;
    font-size: 13px;
  }
  .redbg
  {
    background:#ffd1d1;
    color:inherit
  }
  .ybg
  {
    background:#ffff9c;
    color:inherit
  }
  .greenbg
  {
    color: green;
    cursor:pointer;
  }
  .highcharts-figure .chart-container {
  width: 300px;
  height: 200px;
  float: left;
}
.thead-normal th,.tbody-normal td
{
  border: 1px solid silver!important;
}
.thead-normal tr{
  background:rgb(138, 135, 232);
  color:white
}
.saveBtn
{
  background-color: #b4ffb3;border-radius:0;height: 30px;border: none;width:60px
}
</style>
